import { render, staticRenderFns } from "./Stepper2.vue?vue&type=template&id=0dc3e543&scoped=true"
import script from "./Stepper2.vue?vue&type=script&lang=js"
export * from "./Stepper2.vue?vue&type=script&lang=js"
import style0 from "./Stepper2.vue?vue&type=style&index=0&id=0dc3e543&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3e543",
  null
  
)

export default component.exports